import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { env } from '../env';

/**
 * Identity Platform (Firebase Auth) client.
 *
 * Enabled only when the public web config is present (VITE_IDENTITY_*). When
 * it isn't — local dev without IdP config — the app falls back to the dev
 * email/password stub (see lib/auth.tsx). This lets local development run
 * without the Firebase emulator while the deployed build uses real auth.
 */
export const firebaseEnabled = Boolean(env.VITE_IDENTITY_API_KEY && env.VITE_IDENTITY_PROJECT_ID);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

if (firebaseEnabled) {
  app = initializeApp({
    apiKey: env.VITE_IDENTITY_API_KEY,
    authDomain: `${env.VITE_IDENTITY_PROJECT_ID}.firebaseapp.com`,
    projectId: env.VITE_IDENTITY_PROJECT_ID,
  });
  auth = getAuth(app);
}

export const firebaseAuth = auth;
